import {useHistory} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import {Col, Row} from "react-bootstrap";
import {GetTransactionById} from "../../services/transaction.service";

function ViewDetail(props) {
    const history = useHistory();
    const [data, setData] = useState({});

    useEffect(async () => {
        let id = props.match.params.id;
        await getTransactionById(id);

    }, []);

    const getTransactionById = async (id) => {
        await GetTransactionById(id).then(async (result) => {
            console.log("result --- ", result)
            if (result.status) {
                if (result.data) {
                    let dt = result.data;
                    if (dt) {
                        await setData(
                            {
                                _id: dt._id,
                                fullName: dt.package?.name,
                                price : dt.package?.price,
                                duration : dt.package?.duration,
                                description : dt.package?.description,
                                user_name : dt.user?.fullName,
                                email : dt.user?.email
                            }
                        )
                    }
                }
            } else {
                toast.error(result.data.data.message);
            }
        }).catch((error) => {
            if (error) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast().error(error.data.message);
            }
        })
    }

    return (
        <div className={"EditProfile"}>
            <h3 className="page-heading">Transaction Detail</h3>
            <hr/>
            <div className={"profileCard"}>
                <div className={"profileCardHeader"}>
                    <Row>
                        <Col xs={12} sm={8} md={7} lg={6} xl={7}>
                            <div className={"profileDetails"}>
                                <h4>PACKAGE DETAILS</h4>
                                <p><b>Name:</b> {data?.fullName}</p>
                                <p><b>Price:</b> ${data?.price}</p>
                                <p><b>Duration:</b> {data?.duration} months</p>
                                <p><b>Description:</b> {data?.description}</p>

                            </div>
                        </Col>
                        <Col xs={12} sm={8} md={7} lg={6} xl={7}>
                            <div className={"profileDetails"}>
                                <h4>USER DETAILS</h4>
                                <p><b>Name:</b>  {data?.user_name}</p>
                                <p><b>Email:</b>  {data?.email}</p>
                            </div>
                        </Col>

                    </Row>
                </div>

            </div>
        </div>
    )
}

export default ViewDetail